var _path, _path2, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _path4, _path5, _path6, _g, _path7, _circle4, _path8, _polygon, _path9, _polygon2, _path10, _path11, _path12, _path13, _path14, _path15, _rect9, _polygon3, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aeb423dd-03ff-4648-8e09-4c1290dce31f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 940.22097,
    height: 467.48375,
    viewBox: "0 0 940.22097 467.48375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M775.91757,683.21108v-72.34S804.10924,662.15705,775.91757,683.21108Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M777.659,683.19835,724.36941,634.2771S781.21461,648.19264,777.659,683.19835Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#f1f1f1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "eeb7425a-d208-4c0d-b95e-02be1fa43e7d",
    "data-name": "Rectangle 62",
    x: 0.27109,
    y: 17.4297,
    width: 635.75697,
    height: 301.67771,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "ac098a7d-41e7-4a0b-9ebb-e2b896279a43",
    "data-name": "Rectangle 75",
    x: 18.45077,
    y: 43.29909,
    width: 599.39849,
    height: 251.69914,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "f3d044d2-f865-40f6-878a-97b0cdf0b076",
    "data-name": "Rectangle 80",
    width: 635.75697,
    height: 27.00885,
    fill: "#9e002f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "a41597d3-4560-43a6-897a-86e327d3ab8c",
    "data-name": "Ellipse 90",
    cx: 20.07093,
    cy: 12.49284,
    r: 5.00599,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a8db4b27-72ff-467a-b7ca-497e0ce2cc93",
    "data-name": "Ellipse 91",
    cx: 39.07201,
    cy: 12.49284,
    r: 5.00599,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "ba9869b1-9707-4207-be3c-61cfbe485fac",
    "data-name": "Ellipse 92",
    cx: 58.07398,
    cy: 12.49284,
    r: 5.00599,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M683.11777,444.97173v-2h11.88916l.0769,1.99854-.03833.001Zm-11.88916,0H659.33944v-2h11.88917Zm-23.77833,0H635.56137v-2h11.88891Zm-23.77807,0H611.78305v-2h11.88916Zm-23.77832,0H588.00473v-2h11.88916Zm-23.77832,0H564.22641v-2h11.88916Zm-23.77832,0H540.44833v-2h11.88892Zm-23.77808,0H516.67v-2h11.88916Zm-23.77832,0H494.214a3.07682,3.07682,0,0,1-1.80835-.61279l1.16455-1.626a1.10935,1.10935,0,0,0,.646.23877h10.5647Zm194.94434-11.38037h-2V421.7022h2ZM491.49569,432.313h-2V420.42388h2Zm208.2295-22.5h-2V397.92388h2Zm-208.2295-1.27832h-2V396.64605h2Zm208.2295-22.5h-2V374.14556h2Zm-208.2295-1.27783h-2V372.86773h2Zm208.2295-22.5h-2V350.36773h2Zm-208.2295-1.27832h-2V349.08941h2Zm208.2295-22.5h-2v-4.02881c-.002-3.37256-1.08277-5.67041-2.08618-6.37744l1.15185-1.63477c1.78052,1.2544,2.93213,4.39942,2.93433,8.01172Zm-208.2295-1.27832h-2v-2.75049c0-4.86572,2.01221-8.56641,4.68067-8.60791l.03125,2c-1.13233.01758-2.71192,2.54-2.71192,6.60791Zm192.92237-9.3584H672.5289v-2h11.88916Zm-23.77832,0H648.75058v-2h11.88916Zm-23.77832,0H624.97226v-2h11.88916Zm-23.77808,0H601.19418v-2h11.88916Zm-23.77832,0H577.41586v-2H589.305Zm-23.77832,0H553.63754v-2H565.5267Zm-23.77832,0H529.85922v-2h11.88916Zm-23.77832,0H506.08114v-2h11.88892Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#e4e4e4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "bf5c6f7d-d465-4263-a791-6917df506e29",
    "data-name": "Rectangle 81",
    x: 77.78926,
    y: 116.62313,
    width: 122.56045,
    height: 7.03573,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "f8f2b1f1-beba-472f-8554-cd71efd3f80f",
    "data-name": "Rectangle 82",
    x: 77.78926,
    y: 142.28652,
    width: 189.26053,
    height: 7.03573,
    fill: "#9e002f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "fb4599b7-18da-45bc-afb0-01dc7e2f7680",
    "data-name": "Rectangle 83",
    x: 77.78926,
    y: 166.46384,
    width: 154.24264,
    height: 7.03573,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "fd7cd703-6235-43d3-ac2b-600a626f2c8b",
    "data-name": "Rectangle 84",
    x: 77.78926,
    y: 190.55201,
    width: 90.04477,
    height: 7.03573,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "b510e3d8-1d90-415c-a9f7-f3077d64661d",
    "data-name": "Rectangle 85",
    x: 77.78926,
    y: 214.63847,
    width: 135.90064,
    height: 7.03573,
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M805.506,377.71564a9.68076,9.68076,0,0,0,13.46821-6.24182l34.31588-2.43529-10.87357-14.19011-30.9199,4.4881a9.73323,9.73323,0,0,0-5.99062,18.37912Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#9e616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M939.05265,356.0311l10.80561-6.25239a14.7599,14.7599,0,0,0,5.86567-19.26271l.37078-.11958a15.16693,15.16693,0,0,0-17.54573-7.6238L821.72425,353.86718l4.22434,27.992Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "f8ab5adf-0050-4313-a3fc-6665da3c3657",
    "data-name": "Path 138",
    d: "M833.55034,486.25946H632.75725c-2.05227-.00522-3.71575-3.40736-3.71836-7.608V376.7378c0-4.19978,1.66609-7.601,3.71836-7.608H833.55034c2.05226.00523,3.71574,3.40737,3.71835,7.608V478.65056C837.26608,482.85034,835.59994,486.25418,833.55034,486.25946Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b9db5941-fd9d-4256-9412-6bd09c2c2e67",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b0c1df6c-9d28-49f1-a1f9-a4de637a1a39",
    "data-name": "Ellipse 7",
    cx: 567.44302,
    cy: 193.2216,
    r: 17.55831,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f27b48c9-eb3a-4b88-89bc-f1c9b7ad6b59",
    "data-name": "Path 63",
    d: "M752.39347,463.58662h-86.135a1.76324,1.76324,0,0,1-.32153-.02621l40.73962-70.56263a2.8517,2.8517,0,0,1,4.96513,0l27.34,47.35337,1.31051,2.26543Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#9e002f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fc8cace5-23bc-4b5f-a7ba-908e5d1307f5",
    "data-name": "Path 65",
    d: "M800.35056,463.5875H725.85025L740.286,442.61922l1.0388-1.51059,18.81205-27.32689a3.80658,3.80658,0,0,1,5.65443-.33723,3.39881,3.39881,0,0,1,.27084.33723Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#9e002f"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "b543a181-e408-4cd3-9028-b57a4db0547e",
    "data-name": "Path 138",
    d: "M833.55034,486.25946H632.75725c-2.05227-.00522-3.71575-3.40736-3.71836-7.608V376.7378c0-4.19978,1.66609-7.601,3.71836-7.608H833.55034c2.05226.00523,3.71574,3.40737,3.71835,7.608V478.65056C837.26608,482.85034,835.59994,486.25418,833.55034,486.25946ZM632.75725,372.1728c-1.23187,0-2.22963,2.04528-2.23139,4.56494V478.65056c0,2.51966.99947,4.56233,2.23139,4.565H833.55034c1.23186,0,2.22962-2.04443,2.23138-4.565V376.7378c0-2.51967-.99947-4.56234-2.23138-4.565Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.76692,
    cy: 62.69207,
    r: 23.72361,
    fill: "#9e616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M948.44444,297.71924c-4.42575,4.71437-12.645,2.18359-13.22164-4.25691a7.7805,7.7805,0,0,1,.00979-1.50265c.29775-2.85287,1.94592-5.44292,1.55112-8.45514a4.4339,4.4339,0,0,0-.81146-2.07565c-3.52676-4.72263-11.80555,2.11231-15.134-2.163-2.04092-2.62149.35816-6.74889-1.208-9.67885-2.06709-3.86707-8.18973-1.95944-12.02926-4.07724-4.272-2.35631-4.01644-8.9107-1.20435-12.89742,3.42947-4.862,9.44242-7.45632,15.38045-7.83022s11.83515,1.23129,17.37884,3.39173c6.29874,2.45469,12.54486,5.84712,16.421,11.38563,4.71382,6.73541,5.16745,15.79054,2.81,23.66635C956.95285,288.01685,952.05854,293.86945,948.44444,297.71924Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "815.218 455.858 803.985 455.858 798.641 412.531 815.22 412.532 815.218 455.858",
    fill: "#9e616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M947.97189,683.00478l-36.21937-.00134v-.45812A14.09835,14.09835,0,0,1,925.85011,668.448h.00089l22.12156.0009Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "725.742 455.491 714.815 452.884 719.67 409.5 735.796 413.347 725.742 455.491",
    fill: "#9e616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M855.8915,683.00478l-35.23078-8.4044.10628-.44562a14.09834,14.09834,0,0,1,16.98359-10.442l.00087.0002,21.51775,5.1332Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M883.95694,450.00988,839.92421,657.61463l27.57736-1.66872L915.04941,538.287l7.16612,118.783,30.12274,1.784-.36784-172.046s12.56649-27.04979,1.669-41.81653S883.95694,450.00988,883.95694,450.00988Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M949.582,312.73714l-26.68263-.59445-3.21885,0c-12.8098,10.43614-18.1913,33.65952-19.99053,50.08409l-19.24631,97.81977s48.73975,13.904,76.44148-2.32592l1.54865-64.11016S965.27382,328.429,949.582,312.73714Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M821.814,455.62326a9.68076,9.68076,0,0,0,8.66062-12.056l28.68689-18.98876L842.71715,417.566,817.9967,436.67313a9.73323,9.73323,0,0,0,3.81733,18.95013Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#9e616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M942.86666,354.32712l6.3367-10.75639a14.75991,14.75991,0,0,0-4.36048-19.65819l0,0a14.75992,14.75992,0,0,0-18.763,1.69906L824.21494,426.88278l17.43824,22.30033Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.11048,683.74187h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#cacaca"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 464.15481,
    y: 160.99836,
    width: 2.53839,
    height: 18.93847,
    fill: "#e4e4e4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.806 169.409 473.946 171.141 465.426 161.973 456.904 171.141 455.045 169.409 465.426 158.246 475.806 169.409",
    fill: "#e4e4e4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M594.61044,405.71392a20.30713,20.30713,0,1,1,20.30713-20.30713A20.3301,20.3301,0,0,1,594.61044,405.71392Zm0-38.07587a17.76874,17.76874,0,1,0,17.76874,17.76874A17.7888,17.7888,0,0,0,594.61044,367.63805Z",
    transform: "translate(-129.88952 -216.25813)",
    fill: "#e4e4e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVector);
export default __webpack_public_path__ + "static/media/upload_vector.8e5e4df976c61191cd10cbf8d533ea1a.svg";
export { ForwardRef as ReactComponent };